import React, {useState} from "react";
import {Tree} from "../components/tree/Tree";
import "./projectDetails.scss";
import {PlanTemplates} from "../components/plan-templates/PlanTemplates";
import {useProjectDetailContext} from "../providers/ProjectDetailProvider";
import {ProjectDetailsHeader} from "../components/ProjectDetailsHeader";
import Page from "../../../components/layout/page/Page";
import {NavigationHeader} from "../../../routes";
import Button from "../../../components/ui/Button";
import ConfirmationModal from "../../../components/ui/ConfirmationModal";
import {useTranslation} from "react-i18next";
import {ProjectDetailsModal, Status} from "../../../models/enums";
import {useRefetchProjectTreeOnMount} from "../hooks";
import {SyncMaterialsModal} from "../features/sync-materials";
import {canSyncMaterials} from "../utils";
import BetaOptInBanner from "../../beta-opt-in/BetaOptInBanner";

const ProjectDetails: React.FC = () => {

	useRefetchProjectTreeOnMount()

	const {t} = useTranslation()
	const [modal, setModal] = useState<ProjectDetailsModal>(ProjectDetailsModal.NONE);
	const {planTemplates, header, treeData, projectDetails} = useProjectDetailContext()
	const canSyncMaterialsValue = canSyncMaterials(projectDetails.project)
	const project = projectDetails.project
	const canMigrateFromCompany = !!project?.migrationAvailable
	const isMigrationLoading = projectDetails.migrationStatus === Status.LOADING

	const closeModal = () => { setModal(ProjectDetailsModal.NONE) }
	const openSyncMaterialsModal = () => {
		if (canSyncMaterialsValue) {
			setModal(ProjectDetailsModal.SYNC_MATERIALS)
		}
	}
	const openMigrateFromCompanyModal = () => {
		if (canMigrateFromCompany) {
			setModal(ProjectDetailsModal.MIGRATE_FROM_COMPANY)
		}
	}
	const confirmMigrateFromCompany = async () => {
		if (!project) return
		const succeeded = await projectDetails.migrateFromOtherCompany(project.id)
		if (succeeded) {
			closeModal()
		}
	}

	return (
		<Page>
			{modal === ProjectDetailsModal.SYNC_MATERIALS ? (
				<SyncMaterialsModal onClose={closeModal}/>
			) : null}
			{modal === ProjectDetailsModal.MIGRATE_FROM_COMPANY ? (
				<ConfirmationModal
					isOpen={true}
					isLoading={isMigrationLoading}
					title={t("projects.details.migration.manualTitle")}
					text={t("projects.details.migration.manualMessage")}
					confirmationButtonLabel={t("projects.details.migration.confirmButton")}
					onConfirm={confirmMigrateFromCompany}
					onClose={closeModal}
				/>
			) : null}
			<NavigationHeader>
				{canMigrateFromCompany ? (
					<Button
						variant={"secondary"}
						label={t("projects.details.migration.manualButton")}
						onClick={openMigrateFromCompanyModal}
					/>
				) : null}
				<Button
					variant={"secondary"}
					disabled={!canSyncMaterialsValue}
					label={t("projects.details.syncMaterials")}
					onClick={openSyncMaterialsModal}
				/>
			</NavigationHeader>
			<BetaOptInBanner/>
			<div className="project-details-page">
				<ProjectDetailsHeader {...header}/>
				<div className="project-details-page_content">
					<PlanTemplates {...planTemplates}/>
					<Tree {...treeData}/>
				</div>
			</div>
		</Page>
	);
};

export default ProjectDetails

